<div class="w-100">
  <!-- Range & Unit -->
  <div class="range-unit-row">
    <div class="range-section">
      <div class="section-header">
        <mat-icon>linear_scale</mat-icon>
        <span>{{ "generic.range-value" | translate | titlecase }}</span>
      </div>
      <div class="range-inputs">
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>{{ 'generic.min-vaue' | translate }} </mat-label>
          <input [disabled]="!editable" type="number" required matInput [(ngModel)]="getCustoms.min" [ngModelOptions]="{standalone: true}"
            name="min">
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>{{ 'generic.max-value' | translate }} </mat-label>
          <input [disabled]="!editable" required type="number" matInput [(ngModel)]="getCustoms.max" [ngModelOptions]="{standalone: true}"
            name="max">
        </mat-form-field>
      </div>
    </div>

    <div class="unit-section">
      <div class="section-header">
        <mat-icon>straighten</mat-icon>
        <span>{{ "components.decision-table.new-decision-table.compile-proposal.measure-unit" | translate | titlecase }}</span>
      </div>
      <mat-form-field appearance="fill" class="unit-select">
        <mat-label>{{ 'components.decision-table.new-decision-table.compile-proposal.measure-unit' | translate
        }} </mat-label>
        <mat-select name="proposal_target_primary_criteria_unit" [disabled]="!editable"
          [(ngModel)]="getCustoms.measure_unit" [ngModelOptions]="{standalone: true}" required>
          <mat-option value="" selected></mat-option>
          @for (unit of unitsService.getAllUnitsForSelect(); track unit) {
            <mat-option [value]="unit.key">{{ unit.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Settings Header -->
  <div class="section-header">
    <mat-icon>tune</mat-icon>
    <span>{{ "generic.settings" | translate }}</span>
  </div>

  <!-- Use Slider -->
  <div class="d-flex justify-content-between align-items-center py-2">
    <span>{{ "modals.modal-survey-details.use-slider" | translate }}</span>
    <mat-slide-toggle color="primary" [disabled]="!editable" [(ngModel)]="getCustoms.use_slider" [ngModelOptions]="{standalone: true}"
      name="question_use_slider"></mat-slide-toggle>
  </div>

  @if (getCustoms.use_slider) {
    <!-- Tricolor -->
    <div class="d-flex justify-content-between align-items-center py-1">
      <span class="d-flex align-items-center">
        {{ "modals.modal-survey-details.tricolor-description" | translate }}
      </span>
      <mat-slide-toggle color="primary" [disabled]="!editable" [(ngModel)]="getCustoms.tricolor" [ngModelOptions]="{standalone: true}"
        name="question_tricolor"></mat-slide-toggle>
    </div>
    <!-- Step -->
    <div class="step-row">
      <span class="step-label">{{ "generic.step-value" | translate | titlecase }}</span>
      <mat-form-field appearance="fill" class="step-input" subscriptSizing="dynamic">
        <input [disabled]="!editable" type="number" required matInput [(ngModel)]="getCustoms.step" [ngModelOptions]="{standalone: true}"
          name="step">
      </mat-form-field>
    </div>
    <!-- Custom Labels -->
    <div class="d-flex justify-content-between align-items-center py-1">
      <span class="d-flex align-items-center">
        {{ "generic.customs-min-max-labels" | translate }}
      </span>
      <mat-slide-toggle color="primary" [disabled]="!editable" [(ngModel)]="getCustoms.use_custom_min_max_labels" [ngModelOptions]="{standalone: true}"
        name="question_custom_labels"></mat-slide-toggle>
    </div>
    <!-- Custom Labels Inputs -->
    @if (getCustoms.use_custom_min_max_labels) {
      <div class="custom-labels-inputs">
        <mat-form-field appearance="fill" class="flex-1 pb-0">
          <mat-label>{{ "generic.min" | translate }}</mat-label>
          <input [disabled]="!editable" required matInput [(ngModel)]="getCustoms.min_label" [ngModelOptions]="{standalone: true}" name="min_label">
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-1 pb-0">
          <mat-label>{{ "generic.max" | translate }}</mat-label>
          <input [disabled]="!editable" required matInput [(ngModel)]="getCustoms.max_label" [ngModelOptions]="{standalone: true}" name="max_label">
        </mat-form-field>
      </div>
    }
    <!-- Preview -->
    <div class="preview-section">
      <div class="section-header mb-0">
        <mat-icon>visibility</mat-icon>
        <span>{{ "generic.preview" | translate }}</span>
      </div>
      <div class="preview-content">
        @if (!isResponse) {
          <div class="slider-preview-wrapper" [class.tricolor]="getCustoms?.tricolor">
            <mat-slider class="w-100 cdk-focused" [discrete]="true" color="primary" [disabled]="!editable">
              <input matSliderThumb [max]="getCustoms?.max" [min]="getCustoms?.min" [step]="getCustoms?.step">
            </mat-slider>
          </div>
        }
        <div class="preview-labels">
          @if (!getCustoms.use_custom_min_max_labels) {
            <small>{{ getCustoms.min }}</small>
            <small>{{ getCustoms.max }}</small>
          } @else {
            <small>{{ getCustoms.min_label }}</small>
            <small>{{ getCustoms.max_label }}</small>
          }
        </div>
      </div>
    </div>
  }
</div>
